module.exports = __webpack_public_path__ + "static/img/wangzhan_dingzhi_img.c830f96.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/wangzhan_dingzhi_img.png
// module id = 4S6H
// module chunks = 0